<script setup lang="ts">
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import Icon from '~/components/common/Icon.vue'
import Button from '~/components/common/Button.vue'
import { useDownloadReport } from '~/composables/useDownloadReport'
import { logError } from '@/utils/log-error'

const { openPDFInNewTab } = useDownloadReport()

type TProps = {
  report?: any
  withIcon?: boolean
}

const props = withDefaults(defineProps<TProps>(), {
  report: () => null,
  withIcon: true,
})

const reportHasAccess = computed(() => props.report?.has_access)
const loading = ref(false)

const openPDF = async () => {
  try {
    loading.value = true
    await openPDFInNewTab(props.report.id, props.report.categories[0].slug)
  } catch (error) {
    logError(error)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="flex items-center justify-between w-full">
    <div v-if="reportHasAccess" class="flex items-center gap-3">
      <Button
        class="mx-0 !w-full py-2.5 !text-sm md:!max-w-[150px] group-hover:bg-p-700"
        :variant="withIcon ? 'primary' : 'clean'"
        :show-spinner="loading"
        :disabled="loading"
        @click="openPDF"
      >
        Download
      </Button>
    </div>

    <ButtonContactUs
      v-else
      text="Find Out More"
      variant="clean"
      class="critical-insights-button !py-3 !px-4 bg-white !text-sm !text-black group-hover:bg-p-50"
    />

    <template v-if="withIcon">
      <Icon
        v-if="reportHasAccess"
        name="check-subscribe"
        class="h-8 w-8 stroke-p-900"
      />
      <Icon v-else name="LockOutline" class="h-8 w-8 stroke-p-900" />
    </template>
  </div>
</template>
